import React from 'react'
import { ConfirmationSummaryProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FreeDeliveryRuleState } from './types'
import {
	RuleSummaryArrow,
	RuleSummaryMechanicsRow,
	RuleSummaryStatBadge,
} from '../../CampaignModalSkeleton/components'

export function FreeDeliveryConfirmationSummary({
	rule,
}: ConfirmationSummaryProps<FreeDeliveryRuleState>) {
	return (
		<RuleSummaryMechanicsRow>
			<RuleSummaryStatBadge
				value={`${rule.threshold} €`}
				caption="panier minimum (hors livraison)"
			/>
			<RuleSummaryArrow />
			<RuleSummaryStatBadge value="0 €" caption="frais de livraison" />
		</RuleSummaryMechanicsRow>
	)
}
